import React, { FC, ReactNode } from 'react';
import { Container } from 'src/components/Page/styled';

interface PageProps {
  children: ReactNode;
  height?: string;
  minHeight?: string;
  maxWidth?: string;
}

export const Page: FC<PageProps> = ({
  children,
  maxWidth,
  minHeight,
  height,
}) => (
  <Container height={height} maxWidth={maxWidth} minHeight={minHeight}>
    {children}
  </Container>
);
